import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export const report = (state = initialState.report, action) => {
  switch (action.type) {
    case types.GET_CUSTOMER_PROJECT_STATUS_REPORT_SUCCESS: {
      return action.report;
    }
    case types.GET_MONTHLY_REVENUE_ANALYSIS_REPORT_SUCCESS: {
      return action.report;
    }

    case types.CLEAN_MRA_REPORT: {
      return {};
    }

    case types.CLEAR_REPORT: {
      return {};
    }

    default:
      return state;
  }
};

export const DPSReport = (state = initialState.DPSReport, action) => {
  switch (action.type) {
    case types.LOAD_DPS_REPORT_SUCCESS:
      return action.data;
    default:
      return state;
  }
};

export const PESReport = (state = initialState.PESReport, action) => {
  switch (action.type) {
    case types.LOAD_PES_REPORT_SUCCESS:
      return action.data;
    case types.CLEAR_REPORT:
      return initialState.PESReport;
    default:
      return state;
  }
};

export const resource_summary_report = (
  state = initialState.resource_summary_report,
  action
) => {
  switch (action.type) {
    case types.GET_RESOURCE_SUMMARY_REPORT_SUCCESS:
      return action.resource_summary_report;
    case types.CLEAR_RESOURCE_SUMMARY:
      return initialState.resource_summary_report;
    default:
      return state;
  }
};

export const DCCReport = (state = initialState.DCCReport, action) => {
  switch (action.type) {
    case types.GET_DAILY_CALL_COMPLETION_REPORT_SUCCESS:
      return action.report;
    case types.CLEAR_REPORT:
      return [];
    default:
      return state;
  }
};

export const OSTReport = (state = initialState.OSTReport, action) => {
  switch (action.type) {
    case types.GET_OPEN_SUPPORT_TICKETS_REPORT_SUCCESS:
      return action.report;
    case types.CLEAR_REPORT:
      return [];
    default:
      return state;
  }
};

export const PSAReport = (state = initialState.PSAReport, action) => {
  switch (action.type) {
    case types.GET_PROJECT_SERVICE_ANALYSIS_REPORT_SUCCESS:
      return action.report;
    case types.CLEAR_PROJECT_SERVICE_ANALYSIS_REPORT:
      return initialState.PSAReport;
    default:
      return state;
  }
};
